import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { lastValueFrom } from 'rxjs';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useCRMBonusCode = (zoneId: string) => {
  const { crm } = useDispatch<Dispatch>();
  const request = useRequest();
  const store = useStore();

  const getBonus = useCallback(
    async (contents: string[]) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const [, bonusCode] = contents[0].match('<!--data-bonus-code-tag="(.+?)"-->')!;
      try {
        await lastValueFrom(request({ service: 'wc3.bonus.getCodeInfo', body: { bonusCode } }));
        return { crmBonusCode: bonusCode };
      } catch (e) {
        return { crmBonusCode: '' };
      }
    },
    [request]
  );

  return async () => {
    let contents = select.crm.getZone(store.getState(), zoneId);

    if (contents?.length && contents[0]) {
      return getBonus(contents);
    } else {
      await crm.fetchZone({ zoneId });

      contents = select.crm.getZone(store.getState(), zoneId);
      if (contents?.length && contents[0]) {
        return getBonus(contents);
      } else {
        return { crmBonusCode: '' };
      }
    }
  };
};

export default useCRMBonusCode;
